export enum DocumentLayout {
  Regular,
  List,
}
